import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function usePDPModelSizeTagExperiment(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_MODEL_SIZE_TAG_VISIBILITY)
  const showModelSizeTag = experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW
  return showModelSizeTag
}
